import React from "react";
import { useSnapshot } from "valtio";
import { voiceAgentStore } from "../../../../../store/voiceAgentStore";

const TranscriptDisplay: React.FC = () => {
  const { transcript } = useSnapshot(voiceAgentStore);

  if (!transcript) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400 text-lg animate-pulse">
        Waiting for conversation...
      </div>
    );
  }

  const isUser = transcript.role === "user";

  return (
    <div className="flex flex-col items-center justify-center h-full p-6 max-w-2xl mx-auto w-full">
      <div
        className={`
          relative p-8 rounded-3xl text-2xl font-medium leading-relaxed shadow-lg transition-all duration-500 ease-out transform
          ${
            isUser
              ? "bg-blue-50 text-blue-900 border border-blue-100 translate-x-4"
              : "bg-purple-50 text-purple-900 border border-purple-100 -translate-x-4"
          }
        `}
      >
        {/* Role Label */}
        <div
          className={`
            absolute -top-3 left-6 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm
            ${isUser ? "bg-blue-500 text-white" : "bg-purple-500 text-white"}
          `}
        >
          {isUser ? "You" : "FiBi"}
        </div>

        {/* Text Content */}
        <p className="whitespace-pre-wrap">{transcript.text}</p>
      </div>
    </div>
  );
};

export default TranscriptDisplay;
